import Vue from 'vue';
import axios from 'axios'

const state = {
}

const mutations = {
}

const actions = {
    getFlags({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_ROA}/flags?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_ROA}/flags?mr_id=${params.mr_id}`);
    },
    getROAInfo({ dispatch}, roa_id){
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/document?roa_id=${roa_id}`);
    },
    getBidInfo({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_ROA}/roa/latest/info?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/latest/info?mr_id=${params.mr_id}`);
    },
    getWorkflowInstanceDetails({ dispatch}, workFlow_intance_id){
        return axios.get(`${process.env.VUE_APP_APPROVAL}/approval?workflow_instance_id=${workFlow_intance_id}`);
    },
    publishAward({ dispatch}, params) {
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa/publish`, params);
    },
    getVendorList({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_ROA}/mr/vendors_list?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_ROA}/mr/vendors_list?mr_id=${params.mr_id}`);
    },
    getPublishTimeline({ dispatch}, roa_id){
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/publish/timeline?roa_id=${roa_id}`);
    },
    updateVendorStatus({ dispatch}, params){
        return axios.put(`${process.env.VUE_APP_API_ROA}/mr/vendors_list`, params);
    },
    updateROAContent({ dispatch}, params) {
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa/save/html`, params);
    },
    fetchROAContent({ dispatch}, params) {
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa/view/html`, params);
    },
    initiateROA({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa`, params);
    },
    getROASummaryInfo({ dispatch}, roa_id){
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa?roa_id=${roa_id}`);
    },
    getTimeline({ dispatch}, roa_id) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/timeline?roa_id=${roa_id}`);
    },
    reloadDefaultROAContent({ dispatch}, params) {
        return axios.put(`${process.env.VUE_APP_API_ROA}/roa/html/reset`, params);
    },
    uploadDocs({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa/document`, params);
    },
    generatePreview({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa/printpreview`, params);
    },
    download({commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/download?roa_id=${params.roa_id}`);
    },
    downloadProgress({commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/download/progress?roa_id=${params.roa_id}&file_process_id=${params.file_process_id}`);
    },
    getROARevInfo({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_ROA}/roa/revisions?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/revisions?mr_id=${params.mr_id}`);
    },
    previewFile({ dispatch}, params){
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/document/view?roa_id=${params.roa_id}&document_name=${params.docName}&file_node_id=${params.node_id}`);
    },
    getProjectUsers({state}, params) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/project/user?project=${params.projectId}&roa_id=${params.roa_id}&page=approver`);
    },
    getCollabUsers({ dispatch}, params) {
        return axios.get(`${process.env.VUE_APP_COLLAB}/project/user?project=${params.projectId}&only_prc=${true}&pe_emails=${true}`);
    },
    getDocList({commit}, roa_id) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/document?roa_id=${roa_id}`);
    },
    deleteDocument({ dispatch}, params){
        return axios.delete(`${process.env.VUE_APP_API_ROA}/roa/document`, {data:params});
    },
    inviteForReview({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa/user/review`, params);
    },
    getInvitedUsers({ dispatch}, roa_id) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/user/review?roa_id=${roa_id}`);
    },
    getCollabThreads({commit}, payload) {
        let links = process.env.VUE_APP_COLLAB + '/collab/threads/view?target_id=' + payload.target_id
            if(payload?.dis) {
                links = links + '&discipline=' + payload.dis
            } 
            if(payload?.state) {
                links = links + '&state=' + payload.state
            }
            if(payload?.thread){
                links = links + '&thread_state=' + payload.thread
            }
            return axios({
                url: links,
                method: 'get'
            })
    },
    getWorkflowId({ dispatch}, name){
        return axios.get(`${process.env.VUE_APP_APPROVAL}/workflows?name=${name}`);
    },
    completeReview({ dispatch}, roa_id) {
        return axios.put(`${process.env.VUE_APP_API_ROA}/roa/user/review`, {roa_id:roa_id});
    },
    createRevision({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_ROA}/roa`, params);
    },
    getWorkflow({commit}, payload){
        return axios({
                url: process.env.VUE_APP_APPROVAL + '/workflows',
                method: 'get'
            })
    },
    getPRCUserList({ dispatch}, params) {
        return axios.get(`${process.env.VUE_APP_API_ROA}/roa/project/user?roa_id=${params.roa_id}&project=${params.project_id}&only_prc=True`);
    }
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}